import React, { Fragment } from "react";
import AxiosConfig from "axiosConfig";
import "components/Project/Details/ProjectOldInfo.css";
import Image from "react-bootstrap/Image";
import TextTheme from "components/General/Text/TextTheme";

class ProjectOldInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.project,
      projectName: "",
      projectCategory: [],
      projectTags: "",
      projectBadge: "",
      projectCreators: "",
      projectStarted: "",
    };
  }

  componentDidMount() {
    AxiosConfig.get(`/impactprojects/project/${this.state.projectSlug}/`)
      .then((res) => {
        this.setState({
          projectName: res.data.name,
          projectCategory: res.data.category,
          projectTags: res.data.tags,
          projectBadge: res.data.badge,
          projectMission: res.data.mission,
          projectCreators: res.data.creator.full_name,
        });
      })
      .catch();

    // Get active challenge details if any
    AxiosConfig.get(
      `/impactprojects/active_challenge_details/${this.state.projectSlug}`
    )
      .then((res) => {
        if (res.data.length > 0) {
          let projectStarted = new Date(res.data[0].date_started);
          const formattedProjectStarted = Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
          }).format(projectStarted);
          this.setState({
            projectStarted: formattedProjectStarted,
            challengeName: res.data[0].challenge.name,
          });
        }
      })
      .catch();
  }
  render() {
    return (
      <Fragment>
        {this.props.vertical ? (
          <div className="start_project_info_main_div">
            <div className="start_project_info_container">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <Image
                        src={this.state.projectBadge}
                        className="mb-15 start_project_info_badge_image"
                        roundedCircle
                      />
                    </td>
                  </tr>
                  <tr className="dottedLine">
                    <td valign="top"></td>
                  </tr>
                  <tr>
                    <td>
                      <TextTheme
                        marginTop="20px"
                        marginBottom="20px"
                        fontSize="20px"
                        message={this.state.projectName}
                        className=" mt-15 text_bold text_blue"
                      />
                    </td>
                  </tr>
                  <tr><td><p/></td></tr>
                  <tr>
                    <td valign="top">
                      <b>
                        <TextTheme
                          message="Category"
                          className="text_small text_blue"
                        />
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TextTheme
                        message={this.state.projectCategory.join(", ")}
                        className="text_small"
                      />
                    </td>
                  </tr>
                  <tr><td><p/></td></tr>
                  <tr>
                    <td valign="top">
                      <b>
                        <TextTheme
                          message="Tags"
                          className="text_small text_blue"
                        />
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TextTheme
                        message={this.state.projectTags}
                        className="text_small"
                      />
                    </td>
                  </tr>
                  <tr><td><p/></td></tr>
                  <tr>
                    <td valign="top">
                      <b>
                        <TextTheme
                          message="Mission"
                          className="text_small text_blue"
                        />
                      </b>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <TextTheme
                        message={this.state.projectMission}
                        className="text_small"
                      />
                    </td>
                  </tr>
                  <tr><td><p/></td></tr>
                  <tr>
                    <td valign="top">
                      <b>
                        <TextTheme
                          message="Contributors"
                          className="text_small text_blue"
                        />
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TextTheme message="Katamundi" className="text_small" />
                      <TextTheme
                        message={this.state.projectCreators}
                        className="text_small"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="start_project_info_main_div">
            <div className="start_project_info_container">
              <div className="start_project_info_badge">
                <Image
                  src={this.state.projectBadge}
                  className="start_project_info_badge_image"
                  roundedCircle
                />
                <TextTheme
                  message={this.state.projectName}
                  className="text_medium text_bold text_dark_blue"
                />
              </div>
              {/* <div className="start_project_info_text">
                <table>
                  <tbody>
                    <tr>
                      <td colSpan={2}>
                        <TextTheme
                          message={this.state.projectName}
                          className="text_medium text_bold text_black"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <b>
                          <TextTheme
                            message="Category"
                            className="text_small text_black"
                          />
                        </b>
                      </td>
                      <td>
                        <TextTheme
                          message={this.state.projectCategory.join(", ")}
                          className="text_small text_black"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <b>
                          <TextTheme
                            message="Tags"
                            className="text_small text_black"
                          />
                        </b>
                      </td>
                      <td>
                        <TextTheme
                          message={this.state.projectTags}
                          className="text_small text_black"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <b>
                          <TextTheme
                            message="Mission"
                            className="text_small text_black"
                          />
                        </b>
                      </td>
                      <td>
                        <TextTheme
                          message={this.state.projectMission}
                          className="text_small text_black"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> */}
            </div>
            {this.props.showChallengeDetails ? (
              <div className="project-summary-details">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <TextTheme
                          message={"Challenge : "}
                          className="text_medium text_black"
                        />
                      </td>
                      <td>
                        <TextTheme
                          message={this.state.challengeName}
                          className="text_medium text_black"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <TextTheme
                          message={"Started on : "}
                          className="text_medium text_black"
                        />
                      </td>
                      <td>
                        <TextTheme
                          message={this.state.projectStarted}
                          className="text_medium text_black"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
        )}
      </Fragment>
    );
  }
}

export default ProjectOldInfo;
